import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '../../../services/state.service';

@Component({
    selector: 'tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    standalone: false
})
export class TooltipComponent implements OnInit {
  @Input() title = 'default resuable tooltip ';
  @Input() maxHeight = '';
  @Input() description = 'default resuable tooltip ';
  @Input() showTooltipdark = false;
  @Input() iconColor = 'white';
  @Input() showTooltipBlack = false;


  showModal = false;
  showToolTipText = false;

  constructor(private _state : StateService) {}

  toggleModal() {
    this._state.showBannerComp.next(false);
    this.showModal = !this.showModal;
  }
  closeTooltipModal() {
    this._state.showBannerComp.next(true);
    this.showModal = false;
  }

  showToolTipOnHover() {
    this.showToolTipText = !this.showToolTipText;
  }
  ngOnInit(): void {

  }
}
